import cx from 'classnames'
import React, { useEffect } from 'react'

import { isHouseRelatedType } from '@js/common/utils'

import { QuestionRadioButton } from '@f/applications/QuizApp/questions/QuestionRadio/QuestionRadioButton'
import ActionCardTemplate from '@f/elements/ActionCardTemplate'
import FormWrapper from '@f/elements/FormWrapper'
import Icon from '@f/elements/Icon'

const UserConstructionStart = props => {
  useEffect(() => {
    props.actions.update_wtValue({ value: 'construction-start' })
  }, [])

  const isConversionFunnel = Boolean(props.funnelVariant)

  const handleSelection = value => {
    const detail = {
      construction_start: value
    }

    _wt({
      category: 'form',
      action: 'submit',
      location: 'modal-construction-start',
      values: [
        {
          type: 'construction-start',
          value: value
        }
      ],
      ...props.data.trackingInfo
    })

    props.actions.handleUserDataChange({
      detail,
      forcePostRequest: isHouseRelatedType(props.requestType)
    })
    props.actions.move({})
  }

  const options = [
    {
      value: 'as_soon_as_possible',
      label: 'Ab sofort',
      CardIcon: () => (
        <Icon
          icon='ab-sofort-16px'
          className={cx(
            '[ f-c-st-pri ]',
            isConversionFunnel ? 'f-icon-100' : 'f-icon-050'
          )}
        />
      )
    },
    {
      value: 'within_1_year',
      label: 'Innerhalb 1 Jahres',
      CardIcon: () => (
        <Icon
          icon='less-than-1-year-16px'
          className={cx(
            '[ f-c-st-pri ]',
            isConversionFunnel ? 'f-icon-100' : 'f-icon-050'
          )}
        />
      )
    },
    {
      value: 'within_1_to_2_years',
      label: 'In 1 - 2 Jahren',
      CardIcon: () => (
        <Icon
          icon='within-1-to-2-years-16px'
          className={cx(
            '[ f-c-st-pri ]',
            isConversionFunnel ? 'f-icon-100' : 'f-icon-050'
          )}
        />
      )
    },
    {
      value: 'in_more_than_2_years',
      label: 'In mehr als 2 Jahren',
      CardIcon: () => (
        <Icon
          icon='in-more-than-2-years-16px'
          className={cx(
            '[ f-c-st-pri ]',
            isConversionFunnel ? 'f-icon-100' : 'f-icon-050'
          )}
        />
      )
    }
  ]

  return (
    <FormWrapper
      className={cx(
        'RequestWizard-form-wrapper',
        isConversionFunnel &&
          'RequestWizard-form-wrapper--HDP_conversion-funnel'
      )}
      data-wtloc='modal-construction-start'>
      <div className='RequestWizard-top'>
        <div className='[ f-p-b-020 ] RequestWizard-heading'>
          <div className='[ f-t-tmedium f-c-fo-pri f-t-centre f-p-h-080:m ]'>
            {props.flow.introType === 'floorplan_feedback'
              ? 'Super! Nun werden wir für die von Ihnen geplanten Anpassungen kostenfrei Informationen besorgen'
              : 'Wann wollen Sie mit dem Hausbau beginnen?'}
          </div>
          {props.flow.introType === 'floorplan_feedback' && (
            <div className='[ f-t-centre f-t-body f-c-fo-pri f-p-t-020 f-p-h-080:m ]'>
              Wann wollen Sie mit dem Hausbau beginnen?
            </div>
          )}
        </div>

        <div className='RequestWizard-content'>
          <div className='[ f-overflow ]'>
            <div className='RequestWizard-options-wrapper'>
              {options.map(option => (
                <QuestionRadioButton
                  key={option.value}
                  wtData={{
                    location: 'modal-construction-start',
                    flow_information: props.data.trackingInfo.flow_information
                  }}
                  onClick={() => handleSelection(option.value)}>
                  <ActionCardTemplate
                    sizeActionCard={isConversionFunnel ? 'large' : undefined}
                    {...option}
                  />
                </QuestionRadioButton>
              ))}
            </div>
          </div>
        </div>
      </div>
    </FormWrapper>
  )
}

export default UserConstructionStart
